import React, { Component } from "react";
import authService from "../services/authService";
import { Link } from "react-router-dom";
import myStatusService from "../services/myStatusService";

class IntroProgramming extends Component {
  _isMounted = false;

  state = {
    tutorials: [
      {
        course: "python",
        title: "Grundlagen der Python Programmierung",
        description: "",
        subHeader: "Python Grundkurs",
        link: "/programming/intro/course=python",
        image: "python.svg",
      },
      {
        course: "mlbasics",
        title: "Grundlagen des Maschinellen Lernens ",
        description: "",
        subHeader: "ML Grundkurs",
        link: "/programming/intro/course=mlbasics",
        image: "mlbasics.svg",
      },
    ],
    viewMode: true,
    // Keyed by module key: { [module]: { total_tasks, attempted_tasks } }.
    // Filled from /my-status; empty until the request resolves.
    taskCounts: {},
  };

  componentDidMount() {
    this._isMounted = true;

    let user = authService.getCurrentUser();

    if (!user) {
      this.setState({
        viewMode: true,
      });
      return;
    }

    myStatusService
      .getTaskCountsByModule()
      .then((taskCounts) => {
        if (!this._isMounted) return;
        this.setState({ taskCounts });
      })
      .catch(() => {
        // Leave taskCounts empty: the progress line stays hidden
        // rather than showing a possibly stale number.
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  removeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  render() {
    const { taskCounts } = this.state;
    const user = authService.getCurrentUser();
    let viewMode = true;
    if (user) viewMode = false;

    // The user must be logged in, which it is here.
    const renderStatusContent = (tutorial) => {
      const counts = taskCounts[tutorial.course];
      if (!counts || !counts.total_tasks) return null;
      return `${counts.attempted_tasks}/${counts.total_tasks} Aufgaben bearbeitet`;
    };

    return (
      <React.Fragment>
        <section className="main-content">
          <div className="tiles-container tutorials-tiles">
            {this.state.tutorials.length > 0 &&
              this.state.tutorials.map((tutorial) => (
                <Link
                  to={tutorial.link}
                  className="subpath-tile tutorial"
                  key={tutorial.course}
                >
                  <div className="tile-wrapper">
                    <img
                      style={{ width: "100%" }}
                      src={`/images/icons/subpaths/programming/intro/${tutorial.image}`}
                    />
                    <div className="row2 primary-color-lightblue-background">
                      <div className="tile-sub-header">
                        {tutorial.subHeader}
                      </div>
                      <div className="tile-header fix-height-3">
                        {tutorial.title}
                      </div>
                      {!viewMode && (
                        <div className="tile-status">
                          {renderStatusContent(tutorial)}
                        </div>
                      )}
                    </div>
                  </div>
                </Link>
              ))}
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default IntroProgramming;
